<div *ngIf="!isPDF">
  <compare-actions-toolbar
    [reportData]="reportData"
    [currentView]="currentView"
    [templates]="templateFieldsCatalog"
    [isUKFeaturesEnabled]="isUKFeaturesEnabled"
    (templateChange)="onTemplateSelected($event)"
  >
  </compare-actions-toolbar>
</div>
<div class="condensed-list-wrapper" *ngIf="headerGroups || bodyGroups; else configurationMissing">
  <section *ngFor="let reportItem of reportItems" class="availability-section-container">
    <div [ngClass]="isNewCondensedView ? 'availability-section-new' : 'availability-section'">
      <!-- HEADER -->
      <ng-container>
        <div [ngClass]="{ 'is-highlighted': reportItem.isHighlighted }"></div>
        <rep-condensed-header
          *ngIf="headerGroups != null; else configurationMissing"
          [reportRecordData]="reportItem"
          [reportOptions]="reportOptions"
          [headerGroups]="headerGroups"
          [currentView]="currentView"
          [templateFieldsCatalog]="templateFieldsCatalog"
          [templateProjectionMap]="templateProjectionMap"
          (reportUpdateClick)="reportUpdateClick.emit($event)"
        ></rep-condensed-header>
      </ng-container>

      <ng-template #fullReportHeader>
        <!-- TODO(ppt): implement full header component when required -->
      </ng-template>

      <!-- BODY -->
      <ng-container *ngFor="let record of reportItem.data; let i = index">
        <rep-condensed-body
          *ngIf="bodyGroups; else configurationMissing"
          [isPDF]="isPDF"
          [entity]="reportData.entity"
          [reportOptions]="reportOptions"
          [reportRecordData]="reportItem | condensedRecordData: { recordIndex: i }"
          [allRecords]="reportItems"
          [bodyGroups]="bodyGroups"
          [footerGroups]="footerGroups"
          [currentView]="currentView"
          [templateProjectionMap]="templateProjectionMap"
          [templateFieldsCatalog]="templateFieldsCatalog"
          (removeRecord)="removeRecordFromReport(reportItem, i)"
          (reportUpdateClick)="reportUpdateClick.emit($event)"
        ></rep-condensed-body>
      </ng-container>
      <div class="divider"></div>
    </div>
  </section>
</div>

<ng-template #configurationMissing>
  {{ 'reports.condensedView' | xTranslate }}
</ng-template>
